



function prohibitedWord(word) {

    let listOfBadWords = [
        'SEX',
        'TIT',
        'FAG',
        'GAY',
        'GOD',
        'JEW',
        'CUM',
        'ASS',
        'DIC',
        'DIK',
        'XXX',
        'DUD'
    ]

    if (listOfBadWords.indexOf(word) >= 0) {
        return true;
    } else {
        return false;
    }
}



export function getUniqueId() {
    // console.log('Write a unique id');

    let letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    let firstLetter = Math.floor((Math.random() * 25) + 1);
    // console.log(firstLetter);
    let secondLetter = Math.floor((Math.random() * 25) + 1);
    // console.log(secondLetter);
    let thirdLetter = Math.floor((Math.random() * 25) + 1);
    // console.log(thirdLetter);
    let randomNumber = Math.floor((Math.random() * 99998 + 1));
    // console.log(randomNumber);

    let lettersTogether = firstLetter + secondLetter + thirdLetter;

    if (prohibitedWord(lettersTogether)) {
        return 'AAA' + randomNumber.toString();
    } else {
        return(letters[firstLetter] + letters[secondLetter] + letters[thirdLetter] + randomNumber.toString());
    }


}

